import Csp from "../components/coOpSociety/Csp";

 
import Navbar from "../components/homepage/Navbar";
import { Header, Footer } from "../shared";

const CoOpSociety = () => {
  return (
    <>
      <Header />
      <Csp />
      <Footer />
    </>
  );
};

export default CoOpSociety;
